import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    VStack,
    FormErrorMessage,
} from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    formInputStyles,
} from 'components/forms/new/formStyles';
import NumberField from '@/components/forms/new/formikFormFields/NumberField';

const RulePriorityField = ({ darkMode, errors, touched, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            isInvalid={!!errors.priority && touched.priority}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            isRequired>
            <Stack
                direction="row"
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <Box w="200px">
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Priority
                    </FormLabel>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NumberField}
                            id="priority"
                            name="priority"
                            customWidth="100%"
                            placeholder="Enter priority"
                            validate={(value) =>
                                !value && 'Priority is required'
                            }
                            {...props}
                        />
                        <FormErrorMessage>{errors.priority}</FormErrorMessage>
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Sets the evaluation order when multiple rules exist. The system evaluates rules starting from the lowest number to the highest. If a dialed number matches multiple patterns, the rule with the lowest priority number wins."
                        ariaLabel="rule priority tooltip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default RulePriorityField;
